import { render, staticRenderFns } from "./Step4.vue?vue&type=template&id=88cec69c&scoped=true"
import script from "./Step4.vue?vue&type=script&lang=js"
export * from "./Step4.vue?vue&type=script&lang=js"
import style0 from "./Step4.vue?vue&type=style&index=0&id=88cec69c&prod&lang=scss"
import style1 from "./Step4.vue?vue&type=style&index=1&id=88cec69c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cec69c",
  null
  
)

export default component.exports